// Meta.jsx  (or wherever you defined <Meta>)
import { Helmet } from 'react-helmet-async';

const Meta = ({ metadata = {} }) => {
  const {
    title = "Masala Mobile - Latest News & Updates",
    description = "Stay updated with the latest articles, trending news, and stories.",
    keywords = "",
    // add other fields you use (og:title, canonical, etc.)
  } = metadata;

  return (
    <Helmet>
      <title>{title}</title>
      
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Open Graph / Social Meta */}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content="website" />

      {/* You can add more safe meta tags here */}
    </Helmet>
  );
};

export default Meta;